export type FileManagerPage = 'user' | 'preset' | 'event';

export function isFileManagerPage(mode: string): mode is FileManagerPage {
  return ['user', 'preset', 'event'].includes(mode);
}
